export const CLEAR_BUDGET = 'CLEAR_BUDGET';

export const DELETE_BUDGET = 'DELETE_BUDGET';
export const DELETE_BUDGET_ERROR = 'DELETE_BUDGET_ERROR';
export const DELETE_BUDGET_SUCCESS = 'DELETE_BUDGET_SUCCESS';

export const GET_BUDGETS = 'GET_BUDGETS';
export const GET_BUDGETS_ERROR = 'GET_BUDGETS_ERROR';
export const GET_BUDGETS_SUCCESS = 'GET_BUDGETS_SUCCESS';

export const GET_BUDGET = 'GET_BUDGET';
export const GET_BUDGET_ERROR = 'GET_BUDGET_ERROR';
export const GET_BUDGET_SUCCESS = 'GET_BUDGET_SUCCESS';

export const SAVE_BUDGET = 'SAVE_BUDGET';
export const SAVE_BUDGET_ERROR = 'SAVE_BUDGET_ERROR';
export const SAVE_BUDGET_SUCCESS = 'SAVE_BUDGET_SUCCESS';

export const DOWNLOAD_BUDGET = 'DOWNLOAD_BUDGET';
export const DOWNLOAD_BUDGET_ERROR = 'DOWNLOAD_BUDGET_ERROR';
export const DOWNLOAD_BUDGET_SUCCESS = 'DOWNLOAD_BUDGET_SUCCESS';



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Budget/constants.js